import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Spinner } from 'components';
import { AuxWrap } from 'hoc';
import { EditIcon } from '../../../../../components/Icons';

import s from './style.module.scss';
import { withTranslation } from 'react-i18next';
import i18next from 'i18next';

class DropdownList extends PureComponent {
	state = {
		data: [],
	};

	componentDidMount() {
		this.setState({ data: this.props.data });
	}

	componentDidUpdate(prevProps) {
		const { data } = this.props;

		if (prevProps.data !== data) {
			this.setState({ data: data });
		}
	}

	itemClick = (obj, index) => {
		this.setState((prevState) => {
			const newData = [...prevState.data];
			let showAll = true;

			newData[index].isOpen = !newData[index].isOpen;

			for (let item of newData) {
				showAll = item.isOpen && showAll;
			}

			return { data: newData, showAll: showAll };
		});
	};

	clickAll = (value) => {
		this.setState((prevState) => {
			const newData = prevState.data.map((el) => {
				el.isOpen = value || false;

				return el;
			});

			return { data: newData, showAll: !prevState.showAll };
		});
	};

	renderList = () => {
		const { label } = this.props.config;
		return (
			<AuxWrap>
				<ul className={s.list}>
					{this.state.data.map((el, index) => {
						const classes = [s.listItem];
						let content;

						if (el.isOpen) {
							classes.push(s.open);
							content = (
								<ul className={s.innerList}>
									{el.data.map((el, index) => {
										const classes = [s.displayInline];

										return (
											<li
												className={classes.join(' ')}
												key={index}
												onClick={() => this.props.clicked(el)}
											>
												<div style={{ opacity: el.is_blocked === false ? 1 : 0.3 }}>
													{el.name}
												</div>
												{/* {label} */}
												<div className={s.actionDiv}>
													<div>
														{el.is_blocked === true ? (<svg
															width='80'
															height='30'
															viewBox='0 0 80 30'
															fill='none'
															xmlns='http://www.w3.org/2000/svg'
														>
															<rect width='80' height='30' rx='15' fill='#999999' />
															<path
																d='M18.541 15.1973H16.3613L16.3496 14.0605H18.2188C18.5391 14.0605 18.8066 14.0156 19.0215 13.9258C19.2363 13.8359 19.3984 13.7051 19.5078 13.5332C19.6211 13.3613 19.6777 13.1523 19.6777 12.9062C19.6777 12.6328 19.625 12.4102 19.5195 12.2383C19.418 12.0664 19.2578 11.9414 19.0391 11.8633C18.8203 11.7812 18.543 11.7402 18.207 11.7402H16.8828V19H15.2715V10.4688H18.207C18.6914 10.4688 19.123 10.5156 19.502 10.6094C19.8848 10.6992 20.209 10.8398 20.4746 11.0312C20.7402 11.2227 20.9414 11.4629 21.0781 11.752C21.2188 12.041 21.2891 12.3848 21.2891 12.7832C21.2891 13.1348 21.207 13.459 21.043 13.7559C20.8828 14.0488 20.6348 14.2871 20.2988 14.4707C19.9668 14.6543 19.5449 14.7598 19.0332 14.7871L18.541 15.1973ZM18.4707 19H15.8867L16.5605 17.7344H18.4707C18.791 17.7344 19.0547 17.6816 19.2617 17.5762C19.4727 17.4707 19.6289 17.3262 19.7305 17.1426C19.8359 16.9551 19.8887 16.7402 19.8887 16.498C19.8887 16.2324 19.8418 16.002 19.748 15.8066C19.6582 15.6113 19.5137 15.4609 19.3145 15.3555C19.1191 15.25 18.8613 15.1973 18.541 15.1973H16.8652L16.877 14.0605H19.0098L19.3789 14.5C19.8711 14.5039 20.2715 14.6016 20.5801 14.793C20.8926 14.9844 21.123 15.2305 21.2715 15.5312C21.4199 15.832 21.4941 16.1562 21.4941 16.5039C21.4941 17.0508 21.375 17.5098 21.1367 17.8809C20.9023 18.252 20.5586 18.5312 20.1055 18.7188C19.6562 18.9062 19.1113 19 18.4707 19ZM28.3027 17.7344V19H24.0137V17.7344H28.3027ZM24.5 10.4688V19H22.8887V10.4688H24.5ZM35.9023 14.5176V14.957C35.9023 15.6016 35.8164 16.1816 35.6445 16.6973C35.4727 17.209 35.2285 17.6445 34.9121 18.0039C34.5957 18.3633 34.2188 18.6387 33.7812 18.8301C33.3438 19.0215 32.8574 19.1172 32.3223 19.1172C31.7949 19.1172 31.3105 19.0215 30.8691 18.8301C30.4316 18.6387 30.0527 18.3633 29.7324 18.0039C29.4121 17.6445 29.1641 17.209 28.9883 16.6973C28.8125 16.1816 28.7246 15.6016 28.7246 14.957V14.5176C28.7246 13.8691 28.8125 13.2891 28.9883 12.7773C29.1641 12.2656 29.4102 11.8301 29.7266 11.4707C30.043 11.1074 30.4199 10.8301 30.8574 10.6387C31.2988 10.4473 31.7832 10.3516 32.3105 10.3516C32.8457 10.3516 33.332 10.4473 33.7695 10.6387C34.207 10.8301 34.584 11.1074 34.9004 11.4707C35.2207 11.8301 35.4668 12.2656 35.6387 12.7773C35.8145 13.2891 35.9023 13.8691 35.9023 14.5176ZM34.2734 14.957V14.5059C34.2734 14.041 34.2305 13.6328 34.1445 13.2812C34.0586 12.9258 33.9316 12.627 33.7637 12.3848C33.5957 12.1426 33.3887 11.9609 33.1426 11.8398C32.8965 11.7148 32.6191 11.6523 32.3105 11.6523C31.998 11.6523 31.7207 11.7148 31.4785 11.8398C31.2402 11.9609 31.0371 12.1426 30.8691 12.3848C30.7012 12.627 30.5723 12.9258 30.4824 13.2812C30.3965 13.6328 30.3535 14.041 30.3535 14.5059V14.957C30.3535 15.418 30.3965 15.8262 30.4824 16.1816C30.5723 16.5371 30.7012 16.8379 30.8691 17.084C31.041 17.3262 31.248 17.5098 31.4902 17.6348C31.7324 17.7598 32.0098 17.8223 32.3223 17.8223C32.6348 17.8223 32.9121 17.7598 33.1543 17.6348C33.3965 17.5098 33.5996 17.3262 33.7637 17.084C33.9316 16.8379 34.0586 16.5371 34.1445 16.1816C34.2305 15.8262 34.2734 15.418 34.2734 14.957ZM42.2598 16.1934H43.8711C43.8281 16.7637 43.6699 17.2695 43.3965 17.7109C43.123 18.1484 42.7422 18.4922 42.2539 18.7422C41.7656 18.9922 41.1738 19.1172 40.4785 19.1172C39.9434 19.1172 39.4609 19.0234 39.0312 18.8359C38.6055 18.6445 38.2402 18.373 37.9355 18.0215C37.6348 17.666 37.4043 17.2402 37.2441 16.7441C37.084 16.2441 37.0039 15.6836 37.0039 15.0625V14.4121C37.0039 13.791 37.0859 13.2305 37.25 12.7305C37.4141 12.2305 37.6484 11.8047 37.9531 11.4531C38.2617 11.0977 38.6309 10.8242 39.0605 10.6328C39.4941 10.4414 39.9785 10.3457 40.5137 10.3457C41.209 10.3457 41.7969 10.4746 42.2773 10.7324C42.7578 10.9863 43.1309 11.3359 43.3965 11.7812C43.6621 12.2266 43.8223 12.7383 43.877 13.3164H42.2656C42.2344 12.957 42.1562 12.6523 42.0312 12.4023C41.9102 12.1523 41.7266 11.9629 41.4805 11.834C41.2383 11.7012 40.916 11.6348 40.5137 11.6348C40.2012 11.6348 39.9258 11.6934 39.6875 11.8105C39.4531 11.9277 39.2578 12.1035 39.1016 12.3379C38.9453 12.5684 38.8281 12.8574 38.75 13.2051C38.6719 13.5488 38.6328 13.9473 38.6328 14.4004V15.0625C38.6328 15.4961 38.668 15.8848 38.7383 16.2285C38.8086 16.5723 38.918 16.8633 39.0664 17.1016C39.2148 17.3398 39.4062 17.5215 39.6406 17.6465C39.875 17.7715 40.1543 17.834 40.4785 17.834C40.873 17.834 41.1934 17.7715 41.4395 17.6465C41.6895 17.5215 41.8789 17.3379 42.0078 17.0957C42.1406 16.8535 42.2246 16.5527 42.2598 16.1934ZM46.7305 10.4688V19H45.1191V10.4688H46.7305ZM51.8516 10.4688L48.4297 14.6289L46.4727 16.7207L46.1855 15.1562L47.5449 13.3926L49.877 10.4688H51.8516ZM50.0586 19L47.4043 15.0039L48.5586 13.9609L51.9746 19H50.0586ZM58.3789 17.7344V19H53.8438V17.7344H58.3789ZM54.3359 10.4688V19H52.7246V10.4688H54.3359ZM57.7871 13.9902V15.2266H53.8438V13.9902H57.7871ZM58.3613 10.4688V11.7402H53.8438V10.4688H58.3613ZM62.0469 19H60.207L60.2188 17.7344H62.0469C62.543 17.7344 62.959 17.625 63.2949 17.4062C63.6309 17.1836 63.8848 16.8652 64.0566 16.4512C64.2285 16.0332 64.3145 15.5332 64.3145 14.9512V14.5117C64.3145 14.0625 64.2656 13.666 64.168 13.3223C64.0703 12.9785 63.9258 12.6895 63.7344 12.4551C63.5469 12.2207 63.3145 12.043 63.0371 11.9219C62.7598 11.8008 62.4414 11.7402 62.082 11.7402H60.1719V10.4688H62.082C62.6523 10.4688 63.1719 10.5645 63.6406 10.7559C64.1133 10.9473 64.5215 11.2227 64.8652 11.582C65.2129 11.9375 65.4785 12.3633 65.6621 12.8594C65.8496 13.3555 65.9434 13.9102 65.9434 14.5234V14.9512C65.9434 15.5605 65.8496 16.1152 65.6621 16.6152C65.4785 17.1113 65.2129 17.5371 64.8652 17.8926C64.5215 18.248 64.1113 18.5215 63.6348 18.7129C63.1582 18.9043 62.6289 19 62.0469 19ZM61.1094 10.4688V19H59.498V10.4688H61.1094Z'
																fill='white'
															/>
														</svg>) : ''}
													</div>
													<EditIcon
														onClick={(e) =>
															this.props.onProviderEditClicked(e, el)
														}
													/>
												</div>

											</li>
										);
									})}
								</ul>
							);
						}

						return (
							<li key={index} className={classes.join(' ')}>
								<span
									className={s.label}
									onClick={() => this.itemClick(el, index)}
								>
									{label.view ? label.view(el) : el[label.path]}
								</span>
								{content}
							</li>
						);
					})}
				</ul>
			</AuxWrap>
		);
	};

	render() {
		return (
			<>
				<span
					className={s.btn}
					onClick={() => this.clickAll(!this.state.showAll)}
				>
					{this.props.t(
						this.state.showAll ? 'hide_all_providers' : 'show_all_providers',
					)}
				</span>
				<div className={s.tableTitle}>
					<div className={s.leftAlignedTitle}>
						<span>
							<b>
								{i18next.t('all_providers')}
							</b>
						</span>
					</div>
					<div className={s.rightAlignedTitle}>
						<span>
							<b>{i18next.t('status')}</b>
						</span>
						<span>
							<b>
								{i18next.t('action')}
							</b>
						</span>
					</div>
				</div>
				<div className={s.dropdownList}>
					{!this.props.data.length ? <Spinner /> : this.renderList()}
				</div>
			</>
		);
	}
}

DropdownList.defaultProps = {
	data: [],
	config: {},
};

DropdownList.propTypes = {
	data: PropTypes.array,
	config: PropTypes.object,
};

export default withTranslation()(DropdownList);
